import React, { memo, useCallback, useMemo } from "react";
import { Button, Stack } from "@mui/material";

const ActiveReferralActionsCell = ({ row, type = "sent" }) => {
  const { user, provider, status, id, actions } = row;

  const canSendReferral = user?.referral_permissions?.some(
    (e) => e.key === "SEND_REFERRAL" && e.value
  );
  const isDraft = status?.toLowerCase() === "draft";

  const handleClick = useCallback(
    (e, action, extraArg) => {
      e.stopPropagation();
      action(id, extraArg);
    },
    [id]
  );

  const isManuallyCreated = status === "Manually Created";

  const allButtons = useMemo(
    () => ({
      update: {
        label: "Update Draft",
        show: canSendReferral && isDraft,
        color: "primary",
        onClick: (e) => handleClick(e, actions.onUpdate),
      },
      delete: {
        label: "Delete",
        show: canSendReferral && isDraft,
        color: "primary",
        onClick: (e) => handleClick(e, actions.onDelete),
      },
      view: {
        label: "View",
        show: (provider || isManuallyCreated) && !(canSendReferral && isDraft),
        color: "primary",
        onClick: (e) => handleClick(e, actions.onViewReferral),
      },
      notes: {
        label: "View Notes",
        show: provider || isManuallyCreated,
        color: "primary",
        onClick: (e) => handleClick(e, actions.onViewNotes),
      },
      review: {
        label: "Review",
        show: type === "received",
        color: "primary",
        onClick: (e) => handleClick(e, actions.onReview, row),
      },
      complete: {
        label: "Complete",
        show:
          (type === "sent" && !isDraft) ||
          (type === "received" &&
            ["declined", "scheduled", "ref_completed"].includes(status)),
        color: "primary",
        onClick: (e) => handleClick(e, actions.onComplete),
      },
    }),
    [canSendReferral, isManuallyCreated, isDraft, provider, type, status, handleClick, actions, row]
  );

  const buttonOrder =
    type === "sent"
      ? ["update", "delete", "view", "notes", "complete"]
      : ["notes", "review", "complete"];

  return (
    <Stack direction="row" spacing={1}>
      {buttonOrder
        .map((key) => allButtons[key])
        .filter((btn) => btn.show)
        .map((btn, index) => (
          <Button
            key={index}
            color={btn.color}
            onClick={btn.onClick}
          >
            {btn.label}
          </Button>
        ))}
    </Stack>
  );
};

export default memo(ActiveReferralActionsCell);
